module.exports = __webpack_public_path__ + "static/media/6980.e16e0efd.jpg";